import { create } from "zustand";
import type { Workshop } from "@/content/workshops";

/**
 * The entry the Version History modal is currently inspecting. The
 * `OpenModal` store (useWorkshopModals) only tracks *which* modal is open,
 * not its payload — so the per-entry Clock affordance stashes the target
 * here, then opens the `version-history` modal. RT-VERSIONING.
 */
export type VersionTarget = {
  /** Repo-rooted GitHub path of the entry (`entry.githubPath`). */
  path: string;
  /** Human label shown in the modal header (the entry's label / title). */
  label: string;
  /** Workshop scope — needed to re-upload on restore. */
  workshopId: Workshop["id"];
  /** Which blob tree the entry lives in — picks the restore upload fn. */
  kind: "upload" | "capture";
  /** Current head blob SHA (`entry.githubSha`) — the concurrency token
   *  the restore re-upload passes back to GitHub. */
  sha?: string;
  /** MIME type to wrap the restored bytes in (the entry's mimeType). */
  mimeType?: string;
};

type VersionHistoryState = {
  target: VersionTarget | null;
  setTarget: (target: VersionTarget | null) => void;
};

export const useVersionHistory = create<VersionHistoryState>((set) => ({
  target: null,
  setTarget: (target) => set({ target }),
}));
